import defaultConfig from "./default.config";
import endpointHealthConfig from "./endpointHealth.config";
import smartSandboxConfig from "./smartSandbox.config";
import oracleSandboxConfig from "./oracleSandbox.config";

const CONFIG_TIMEOUT_MS = 3000;

function getConfigServerUrl() {
  const host = window.location.hostname.toLowerCase();

  if (host.includes("uat.endpointhealth.ca")) {
    return "https://pcom-config-uat.onrender.com/api/config";
  }

  if (host.includes("launch.endpointhealth.ca")) {
    return "https://pcom-config-prd.onrender.com/api/config";
  }

  return "https://pcom-config-dev.onrender.com/api/config";
}

export async function loadOrgConfig(iss) {
  console.log("loadOrgConfig invoked with ISS:", iss);

  if (!iss) {
    console.warn("No ISS provided - using default config.");
    return defaultConfig;
  }

  const configServerUrl = getConfigServerUrl();

  console.log(
    "Using configuration server:",
    configServerUrl
  );

  try {
    const configPromise = fetch(
      configServerUrl + "?iss=" + encodeURIComponent(iss)
    ).then(function (response) {
      if (!response.ok) {
        throw new Error(
          "Configuration server returned HTTP " + response.status
        );
      }

      return response.json();
    });

    const timeoutPromise = new Promise(function (_, reject) {
      setTimeout(function () {
        reject(new Error("Configuration server timeout"));
      }, CONFIG_TIMEOUT_MS);
    });

    const config = await Promise.race([
      configPromise,
      timeoutPromise
    ]);

    if (!config) {
      throw new Error(
        "Configuration server returned no configuration."
      );
    }

    console.log(
      "Remote configuration loaded successfully."
    );

    return config;
  } catch (error) {
    console.warn(
      "Remote configuration unavailable - using local fallback.",
      error
    );

    return getLocalFallbackConfig(iss);
  }
}

function getLocalFallbackConfig(iss) {
  console.log("Loading local fallback configuration.");

  let host;

  try {
    host = new URL(iss).host.toLowerCase();
  } catch (error) {
    console.error(
      "Failed to parse ISS:",
      iss,
      error
    );

    return defaultConfig;
  }

  if (host.includes("launch.smarthealthit.org")) {
    console.log(
      "Using local SMART Sandbox config."
    );

    return smartSandboxConfig;
  }

  if (host.includes("localhost")) {
    console.log(
      "Using local EndpointHealth config."
    );

    return endpointHealthConfig;
  }

  if (host.includes("cerner.com")) {
    console.log(
      "Using local Oracle Health config."
    );

    return oracleSandboxConfig;
  }

  console.warn(
    "Host did not match known configs - using default."
  );

  return defaultConfig;
}